import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaFacebookF, FaLinkedin, FaSuitcaseRolling } from "react-icons/fa";
import { useSelector } from "react-redux";
import { AiFillShopping, AiFillHeart, AiFillInstagram } from "react-icons/ai";
import { FaUserDoctor } from "react-icons/fa6";
import ScrollTop from "./ScrollTop";
import { RiHomeHeartFill, RiWhatsappFill } from "react-icons/ri";
import { BsBagHeartFill } from "react-icons/bs";
import { MdChromeReaderMode, MdAddShoppingCart } from "react-icons/md";
import PopupMenu from "./PopupMenu";

const Footer = () => {
  const { card_product_count, wishlist_count } = useSelector(
    (state) => state.card
  );
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.auth);

  return (
    <footer
      className=" bg-cover bg-no-repeat bg-center"
      style={{
        backgroundImage: `url(${process.env.REACT_APP_CLIENT_URL}/images/homebg.jpg)`,
      }}
    >
      <div className="w-[85%] flex flex-wrap mx-auto border-b py-16 md-lg:pb-10 sm:pb-6 ">
        <div className="w-3/12 lg:w-4/12 sm:w-full">
          <div className="flex flex-col gap-3">
            <img
              className="w-[190px] h-[70x]"
              src={`${process.env.REACT_APP_CLIENT_URL}/images/logo.png`}
              alt="logo"
            />
            <ul className="flex flex-col gap-2 text-slate-200 text-right">
              <li>
                العنوان : جامعة باجي مختار - عنابة (القطب الجامعي سيدي عاشور){" "}
              </li>
              <li> +213 671 75 45 91 : الهاتف </li>
              <li> contact@tabbibi.com : البريد الإلكتروني </li>
            </ul>
          </div>
        </div>
        <div className="w-5/12 lg:w-8/12 sm:w-full">
          <div className="flex justify-center sm:justify-end sm:mt-6 w-full text-right">
            <div>
              <h2 className="gradient-t0 mb-2"> روابط مفيدة </h2>
              <div className="flex justify-between gap-[80px] lg:gap-[40px]">
                <ul className="flex flex-col gap-2 text-slate-200 text-sm ">
                  <li>
                    <Link to="/about">معلومات عنا</Link>
                  </li>
                  <li>
                    <Link to="/doctors"> الأطباء </Link>
                  </li>

                  <li>
                    <Link to="/privacy-policy">سياسة الخصوصية</Link>
                  </li>
                  <li>
                    <Link to="/blogs"> مقالاتنا </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="w-4/12 lg:w-full lg:mt-6">
          <div className="w-full flex flex-col justify-start gap-5 text-right">
            <h2 className="gradient-t0"> ابقى على اطلاع </h2>
            <span className="text-slate-200">
              ابقَ على اطلاع من خلال متابعتنا على شبكات التواصل الاجتماعي لمعرفة
              أحدث خدماتنا
            </span>

            <ul className="flex justify-end items-center gap-3">
              <li>
                <Link
                  className="w-[32px] h-[32px] flex justify-center items-center round-btn"
                  to="https://www.facebook.com/profile.php?id=100094522181755&mibextid=ZbWKwL"
                  target="_blank"
                >
                  <FaFacebookF />
                </Link>
              </li>
              <li>
                <Link
                  className="w-[32px] h-[32px] flex justify-center items-center round-btn"
                  to="https://www.instagram.com/tabbibi360?igsh=MXA3Z2VkZHQ1b3ZvYw=="
                  target="_blank"
                >
                  <AiFillInstagram />
                </Link>
              </li>
              <li>
                <Link
                  className="w-[32px] h-[32px] flex justify-center items-center round-btn"
                  to="https://wa.me/qr/4RIJE7RR7MEUH1"
                  target="_blank"
                >
                  <RiWhatsappFill />
                </Link>
              </li>
              <li>
                <Link
                  className="w-[32px] h-[32px] flex justify-center items-center round-btn"
                  to="https://www.linkedin.com/in/tabbibi-com-1a181b304?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                  target="_blank"
                >
                  <FaLinkedin />
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className=" flex flex-wrap justify-center items-center text-md sm:text-xs text-slate-200 mx-auto px-3 py-5 text-center md:mb-20 backdrop-blur-md">
        <span>Copyright ©2025 All Rights Reserved</span>
      </div>

      <div className="hidden fixed md-lg:block w-[90%] bottom-0 left-3 h-[90px] p-2">
        <div className="w-full h-full flex gap-3 flex-row justify-center items-center">
          <div
            onClick={() => navigate("/")}
            className="mobile-b-icons bg-mainColor/40"
          >
            <RiHomeHeartFill className="text-3xl " />
            <button className="text-[8px]">Accueil</button>
          </div>
          <div
            onClick={() => navigate("/doctors")}
            className="mobile-b-icons bg-mainColor/40"
          >
            <FaUserDoctor className="text-2xl " />
            <button className="text-[8px]">Doctors</button>
          </div>
          <div
            onClick={() => navigate("/products")}
            className="mobile-b-icons bg-mainColor/40"
          >
            <MdAddShoppingCart className="text-2xl" />
            <button className="text-[8px]">Produits</button>
          </div>
          <div
            onClick={() => navigate("/blogs")}
            className="mobile-b-icons bg-mainColor/40"
          >
            <MdChromeReaderMode className="text-2xl" />
            <button className="text-[8px]">Blogs</button>
          </div>
          <div
            onClick={() => navigate(userInfo ? "/card" : "/login")}
            className="mobile-b-icons bg-mainColor/40"
          >
            <span className="relative flex flex-col align-middle justify-center items-center">
              <AiFillShopping className="text-2xl" />
              <button className="text-[8px]">Panier</button>
            </span>
            {card_product_count !== 0 && (
              <div className="w-[20px] h-[20px] absolute bg-green-500 rounded-full text-white flex justify-center items-center -top-[3px] -right-[5px]">
                {card_product_count}
              </div>
            )}
          </div>
          <div className="mobile-b-icons bg-[#2ed139c9]">
            <Link
              className="w-full h-full text-3xl flex justify-center items-center"
              to="https://wa.me/qr/4RIJE7RR7MEUH1"
              target="_blank"
            >
              <RiWhatsappFill />
            </Link>
          </div>
        </div>
      </div>
      <ScrollTop />
      <PopupMenu />
    </footer>
  );
};

export default Footer;
